// extracted by mini-css-extract-plugin
export default {"side-box-sub-tit":"EnvPage_side-box-sub-tit__3OcxM"};